import React from 'react'
import { Col } from 'react-bootstrap'
import { ChevronRight } from 'react-bootstrap-icons'
import styles from './MenuOptions.module.scss'
import { useNavigate } from 'react-router-dom'
export default function MenuOptions(props) {
    const { title, options, column, link } = props
    const navigate = useNavigate();
    const handleNavigate = (link) => {
        //e.preventDefault();
        /* const encodedSearchText = encodeURIComponent(searchText);
        const absoluteURL = `/search/?keywords=${encodedSearchText}` */;
        if (link) {
            window.location.href = link;
        }
    };
    return (
        <Col lg={column !== undefined ? 12 : 4} md={column !== undefined ? 12 : 4} s={column !== undefined ? 12 : 6} xs={column !== undefined ? 12 : 12}>
            <div className={`${styles.optionList}`}>
                <div className={link ? `${styles.title} ${styles.active}` : `${styles.title}`} onClick={() => handleNavigate(link)}>
                    <ChevronRight className={`${styles.icon}`} />
                    <div className={`${styles.text}`}>
                        {title}
                    </div>
                </div>
                <div className={`${styles.options}`}>
                    <ul className={`${styles.list}`} style={{ columns: column !== undefined ? column : '1' }}>
                        {
                            options.map((option, index) => (
                                option.link ? (
                                    <li className={`${styles.op}`} key={index} onClick={option.newWindow ? (() => window.open(option.link, '_blank', 'noreferrer')) : (() => handleNavigate(option.link))}>
                                        {option.title}
                                    </li>
                                ) : (
                                    <li className={`${styles.nonop}`} key={index}>
                                        {option.title}
                                    </li>
                                )
                            ))
                        }
                    </ul>
                </div>
            </div>
        </Col>
    )
}
